import { CLAIMS_DICTIONARY } from "./dictionary.constant";

const claimsOptions = Object.keys(CLAIMS_DICTIONARY).map(key => ({
    label: CLAIMS_DICTIONARY[key],
    value: key,
}));

export default claimsOptions;
